<template>
  <div class="operate">
    <div class="cf">
      <div class="fl">
        <h2 style="margin: 0 0 10px 0">
          互链时空 场站运营驾驶舱
          <el-radio-group @change="changeTenant()" size="mini" v-model="state" style="margin-left: 10px"
            :disabled="loading">
            <el-radio-button label="0">场站统计</el-radio-button>
            <el-radio-button label="1">上煤活跃度</el-radio-button>
            <el-radio-button label="2">新增用户</el-radio-button>
          </el-radio-group>
        </h2>
      </div>
      <div class="fr">
        <el-date-picker v-model="data.valueTime" type="month" placeholder="选择月份" :clearable="false"
          value-format="yyyy-MM" @change="changeTenant()" style="width: 140px; margin: 0 10px 10px 10px" size="mini">
        </el-date-picker>
        <el-select filterable v-model="data.platformId" style="width: 140px; margin-right: 10px" placeholder="选择场站"
          size="mini" @change="changeTenant()">
          <el-option v-for="(item, index) in list" :label="item.name" :value="item.id" :key="index">
          </el-option>
        </el-select>
        <el-select filterable v-model="data.tenantId" style="width: 140px" placeholder="选择企业" size="mini"
          @change="dateValue()" v-if="state !== '0'">
          <el-option v-for="(item, index) in tenantList" :label="item.name" :value="item.id" :key="index">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="cf background-blue">
      {{ state === '0' ? '场站统计' : state === '1' ? '上煤活跃度' : '新增用户' }}
      <div class="fr">
      </div>
    </div>
    <div style="height: 89%;" v-loading="loading">
      <iframe ref="Iframe" :src="src" frameborder="0" width="100%" height="100%" :name="name"></iframe>
    </div>
  </div>
</template>
<script>
import XEUtils from 'xe-utils'

export default {
  name: "operate",
  data() {
    return {
      src: "",
      name: "场站驾驶舱",
      data: {
        valueTime: "",
        platformId: null,
        tenantId: null
      },
      loading: false,
      list: [],
      tenantList: [],
      state: '0'
    };
  },
  created() {
    this.state = '0'
    this.$axios.get("/account/platform/all").then((res) => {
      if (res) {
        this.$set(this, 'list', res.data.data)
        this.$set(this.data, 'platformId', this.list[0].id)
        const time = XEUtils.toDateString(new Date(), 'yyyy-MM')
        this.$set(this.data, 'valueTime', time)
        this.changeTenant()
      }
    }).catch((err) => {
      console.log("场站列表错误：", err);
    });
  },
  mounted() {
    this.$validate.ToDocumentTitle()
  },
  methods: {
    changeTenant() {
      this.$set(this, 'tenantList', [])
      if (this.state === '1') {
        this.$axios.get(`/order/internal/SmPlanTenant/getPlantFormTenant?outtime=${this.data.valueTime}&platformId=${this.data.platformId}`).then(res => {
          this.$set(this, 'tenantList', res.data.data)
          if (this.tenantList.length > 0) {
            this.$set(this.data, 'tenantId', this.tenantList[0].id)
          } else {
            this.$set(this.data, 'tenantId', null)
          }
          this.dateValue();
        })
      } else if (this.state === '2') {
        let config = {
          headers: {
            platformId: this.data.platformId
          }
        }
        this.$axios.get('/platform/tenant/list', config).then(res => {
          res.data.data.forEach(item => {
            this.tenantList.push({ id: item.tenantId, name: item.tenantName })
          })
          if (this.tenantList.length > 0) {
            this.$set(this.data, 'tenantId', this.tenantList[0].id)
          } else {
            this.$set(this.data, 'tenantId', null)
          }
          this.dateValue();
        })
      } else {
        this.dateValue()
      }
    },
    dateValue() {
      if (!['', null, undefined].includes(this.data.valueTime)) {
        let token = localStorage.getItem('token')
        this.loading = true
        this.src = "";
        if (this.state === '0') {
          this.src = `https://platform.wechain360.com/ureport/preview?_u=db:hlsk_platform_cockpit_copy.ureport.xml&outtime=${this.data.valueTime}&platformId=${this.data.platformId}&math=${Math.random()}&token=${token}`;
        } else if (this.state === '1') {
          if (this.data.tenantId) {
            this.src = `https://platform.wechain360.com/ureport/preview?_u=db:hlsk_tenant_smPlan_active.ureport.xml&outtime=${this.data.valueTime}&platformId=${this.data.platformId}&tenantId=${this.data.tenantId}&math=${Math.random()}&token=${token}`
          } else {
            this.src = `https://platform.wechain360.com/ureport/preview?_u=db:hlsk_tenant_smPlan_active.ureport.xml&outtime=${this.data.valueTime}&platformId=${this.data.platformId}&math=${Math.random()}&token=${token}`
          }
        } else {
          if (this.data.tenantId) {
            this.src = `https://platform.wechain360.com/ureport/preview?_u=db:hlsk_tenant_new_user_active.ureport.xml&outtime=${this.data.valueTime}&platformId=${this.data.platformId}&tenantId=${this.data.tenantId}&math=${Math.random()}&token=${token}`
          } else {
            this.src = `https://platform.wechain360.com/ureport/preview?_u=db:hlsk_tenant_new_user_active.ureport.xml&outtime=${this.data.valueTime}&platformId=${this.data.platformId}&math=${Math.random()}&token=${token}`
          }
        }
        const iframe = this.$refs.Iframe;
        if (iframe.attachEvent) {
          iframe.attachEvent("onload", () => {
            this.loading = false;
          });
        } else {
          iframe.onload = () => {
            this.loading = false;
          };
        }
      } else {
        this.$message.warning("请选择时间");
      }
    }
  }
}
</script>
<style>
.operate {
  padding: 20px;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.cf {
  overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.background-blue {
  width: 100%;
  margin: 10px 0;
  background: #66ccff;
  padding: 5px 10px;
  box-sizing: border-box;
  text-align: center;
  font-weight: bold;
}
</style>
